import React, {Component} from 'react';
import FileUploadThumbnail from "file-upload-thumbnail";
import {removeWordFromList} from "../../utility";

const filterProfanity = (props, name, newValue) => {
    const broadcaster_id = props.account_management && props.account_management.userDetails.broadcaster[0].id;
    const newData = removeWordFromList(
        broadcaster_id,
        props.profanity,
        newValue,
        true,
        false
    );

    props.dispatch(props.change(name, newData));
    return newData;
}

const getBase64 = (blob,callback)=>{
    let reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function() {
        let base64data = reader.result.split(',')[1];
        callback(base64data);
    }
}
const getThumbnail = (file,callback)=>{
    new FileUploadThumbnail({
        maxWidth: 800,
        maxHeight: 450,
        file: file,
        onSuccess: function(base64){

            fetch(base64)
                .then(res => res.blob())
                .then((blob) => {
                    callback(blob);
                });
        }
    }).createThumbnail();
}

const getDuration = (blob,callback)=>{
    const media = new Audio(blob);
    media.onloadedmetadata = function () {
        const duration = parseInt(`${media.duration}`);
        callback(duration)
    }
}


export default {
    filterProfanity,
    getThumbnail,
    getBase64,
    getDuration
}